export const FILTERS_TYPE_ITEMS = [
  { value: 'image', text: 'Изображения' },
  { value: 'video', text: 'Видео' },
];

export const FILTER_SYSTEM_TYPE_ITEMS = [
  { value: 'filter', text: 'Фильтр' },
  { value: 'text', text: 'Промпт' },
  { value: 'image', text: 'Изображение' },
  { value: 'text_and_image', text: 'Промпт и изображение' },
];

export const TEMPLATE_TYPE_ITEMS = [
  { value: 'image', text: 'Изображение' },
  { value: 'video', text: 'Видео' },
];

export const TEMPLATE_INPUT_TYPE_ITEMS = [
  { value: 'single', text: 'Одно изображение' },
  { value: 'multiple', text: 'Два изображения' },
];

export const TEMPLATE_MODEL_ITEMS = {
  image: [
    { value: 'gemini_2.5_flash', text: 'Gemini 2.5 Flash' },
    { value: 'gen4_image', text: 'Gen4 Image' },
    { value: 'gen4_image_turbo', text: 'Gen4 Image Turbo' },
  ],
  video: [
    { value: 'veo3', text: 'Veo3' },
    { value: 'veo3.1', text: 'Veo3.1' },
    { value: 'veo3.1_fast', text: 'Veo3.1 Fast' },
    { value: 'veo3.1_no_audio', text: 'Veo3.1 (no audio)' },
    { value: 'veo3.1_fast_no_audio', text: 'Veo3.1 Fast (no audio)' },
    { value: 'gen3a_turbo', text: 'Gen3a Turbo' },
    { value: 'gen4_turbo', text: 'Gen4 Turbo' },
  ],
};

export const TEMPLATE_DURATION_ITEMS = {
  veo3: [8],
  'veo3.1': [4, 6, 8],
  'veo3.1_fast': [4, 6, 8],
  'veo3.1_no_audio': [4, 6, 8],
  'veo3.1_fast_no_audio': [4, 6, 8],
  gen3a_turbo: [5, 10],
  gen4_turbo: [2, 3, 4, 5, 6, 7, 8, 9, 10],
};

export const TEMPLATE_RATIO_ITEMS = {
  gen4_turbo: [
    { value: '720:1280', text: '720:1280' },
    { value: '832:1104', text: '832:1104' },
    { value: '960:960', text: '960:960' },
    { value: '1104:832', text: '1104:832' },
    { value: '1280:720', text: '1280:720' },
    { value: '1584:672', text: '1584:672' },
  ],

  gen3a_turbo: [
    { value: '768:1280', text: '768:1280' },
    { value: '1280:768', text: '1280:768' },
  ],

  ...Object.assign(
    {},
    ...[
      'veo3',
      'veo3.1',
      'veo3.1_fast',
      'veo3.1_no_audio',
      'veo3.1_fast_no_audio',
    ].map((model) => ({
      [model]: [
        { value: '720:1280', text: '720:1280' },
        { value: '1080:1920', text: '1080:1920' },
        { value: '1280:720', text: '1280:720' },
        { value: '1920:1080', text: '1920:1080' },
      ],
    })),
  ),

  ...Object.assign(
    {},
    ...['gen4_image_turbo', 'gen4_image'].map((model) => ({
      [model]: [
        { value: '720:720', text: '720:720' },
        { value: '720:960', text: '720:960' },
        { value: '720:1280', text: '720:1280' },
        { value: '1024:1024', text: '1024:1024' },
        { value: '1080:1080', text: '1080:1080' },
        { value: '1080:1440', text: '1080:1440' },
        { value: '1080:1920', text: '1080:1920' },
        { value: '960:720', text: '960:720' },
        { value: '1168:880', text: '1168:880' },
        { value: '1280:720', text: '1280:720' },
        { value: '1360:768', text: '1360:768' },
        { value: '1440:1080', text: '1440:1080' },
        { value: '1680:720', text: '1680:720' },
        { value: '1808:768', text: '1808:768' },
        { value: '1920:1080', text: '1920:1080' },
        { value: '2112:912', text: '2112:912' },
      ],
    })),
  ),

  'gemini_2.5_flash': [
    { value: '768:1344', text: '768:1344' },
    { value: '832:1248', text: '832:1248' },
    { value: '864:1184', text: '864:1184' },
    { value: '896:1152', text: '896:1152' },
    { value: '1024:1024', text: '1024:1024' },
    { value: '1152:896', text: '1152:896' },
    { value: '1184:864', text: '1184:864' },
    { value: '1248:832', text: '1248:832' },
    { value: '1344:768', text: '1344:768' },
    { value: '1536:672', text: '1536:672' },
  ],
};
